import React, { useState } from "react";
import { Box, Typography, Button } from "@mui/material";
import { useSearchParams } from "react-router-dom";
import { verifyEmail } from "../api/user";

const VerifyEmailView = () => {
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [params] = useSearchParams();
  const token = params.get("token");

  const containerStyle = {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    height: "100%",
    alignItems: "center",
    justifyContent: "center",
    px: 16,
    gap: 5
  };

  const boxStyle = {
    width: 400,
    display: "flex",
    flexDirection: "column",
    p: 2,
    alignItems: "center",
    gap: 2
  };

  const submit = async () => {
    console.log("--submit--");
    const result = await verifyEmail(token);
    console.log("---result---", result);

    if (result.status) {
      switch (result.status) {
        case 200:
          setSuccess("Your email has been successfully verified!");
          setError("");
          break;
        case 201:
          setSuccess("Your email is already verified!");
          setError("");
          break;
        case 400:
          setError(`Missing token"}`);
          setSuccess("");
          break;
        case 404:
          setError(`Token not found`);
          setSuccess("");
          break;
        case 410:
          setError(`Verification link has expired."}`);
          setSuccess("");
          break;
        case 500:
          setError(`Email verification failed: ${result.message || "An unknown error occurred."} Please try again or contact support.`);
          setSuccess("");
          break;
        default:
          setError("Invalid verification status provided.");
          setSuccess("");
          break;
      }
    } else {
      setError("No verification status found. Please use the link from your email.");
    }
  };

  return (
    <Box sx={containerStyle}>
      <Box sx={boxStyle}>
        <img width={100} alt="logotext" src="assets/logos/SmartLog.png" />
        <img width={200} alt="logotext" src="assets/logos/smartLogo_text.png" />
      </Box>

      {error === "" && success === "" && (
        <Box sx={boxStyle}>
          <Button variant="contained" onClick={submit} sx={{ m: 1, width: "100%" }}>
            Verify Email
          </Button>
        </Box>
      )}

      <Box sx={boxStyle}>
        {error && (
          <Typography variant="subtitle1" sx={{ color: "#FF0000", textAlign: "center" }}>
            {error}
          </Typography>
        )}
        {success && (
          <Typography variant="subtitle1" sx={{ color: "#FF0000", textAlign: "center" }}>
            {success}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default VerifyEmailView;
